module.exports = __webpack_public_path__ + "media/images/lb/838-359de76e63422a431c8c4d8106153613.svg";